export interface BlocoPaginacaoMeta {
  manterComProximo?: boolean;
  novaPagina?: boolean;
  paginaInteira?: boolean;
}

export interface PaginaDistribuida {
  indices: number[];
  paginaInteira: boolean;
}

interface DistribuirBlocosParams {
  blocos: BlocoPaginacaoMeta[];
  alturas: number[];
  alturaPrimeiraPagina: number;
  alturaDemaisPaginas: number;
}

function agruparPorManterJunto(blocos: BlocoPaginacaoMeta[]): number[][] {
  const grupos: number[][] = [];
  let grupoAtual: number[] = [];

  blocos.forEach((bloco, index) => {
    grupoAtual.push(index);
    if (!bloco.manterComProximo || bloco.paginaInteira) {
      grupos.push(grupoAtual);
      grupoAtual = [];
    }
  });
  if (grupoAtual.length > 0) {
    grupos.push(grupoAtual);
  }

  return grupos;
}

export function distribuirBlocosEmPaginas({
  blocos,
  alturas,
  alturaPrimeiraPagina,
  alturaDemaisPaginas,
}: DistribuirBlocosParams): PaginaDistribuida[] {
  const grupos = agruparPorManterJunto(blocos);
  const paginas: PaginaDistribuida[] = [];
  let indicesAtuais: number[] = [];
  let alturaAtual = 0;

  const alturaDisponivel = () =>
    paginas.length === 0 ? alturaPrimeiraPagina : alturaDemaisPaginas;

  const fecharPagina = () => {
    if (indicesAtuais.length === 0) return;
    paginas.push({ indices: indicesAtuais, paginaInteira: false });
    indicesAtuais = [];
    alturaAtual = 0;
  };

  const colocarBlocoABloco = (grupo: number[]) => {
    for (const index of grupo) {
      const alturaBloco = alturas[index] ?? 0;
      if (indicesAtuais.length > 0 && alturaAtual + alturaBloco > alturaDisponivel()) {
        fecharPagina();
      }
      indicesAtuais.push(index);
      alturaAtual += alturaBloco;
    }
  };

  grupos.forEach((grupo) => {
    const primeiroBloco = blocos[grupo[0]];
    if (primeiroBloco.paginaInteira) {
      fecharPagina();
      paginas.push({ indices: grupo, paginaInteira: true });
      return;
    }

    const alturaGrupo = grupo.reduce((soma, index) => soma + (alturas[index] ?? 0), 0);
    const deveQuebrar =
      indicesAtuais.length > 0 &&
      (primeiroBloco.novaPagina || alturaAtual + alturaGrupo > alturaDisponivel());

    if (deveQuebrar) {
      fecharPagina();
    }

    if (grupo.length > 1 && alturaGrupo > alturaDemaisPaginas) {
      colocarBlocoABloco(grupo);
      return;
    }

    indicesAtuais.push(...grupo);
    alturaAtual += alturaGrupo;
  });

  fecharPagina();

  return paginas;
}
